import { focusElementAfterScroll } from './focusManagement';

/**
 * Scroll to an element by ID.
 * Offset is handled entirely by CSS `scroll-margin-top` on the target,
 * so this works consistently across devices, orientations, and header sizes.
 */
export const scrollToElement = (targetId: string): boolean => {
  const element = document.getElementById(targetId);
  if (!element) return false;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  element.scrollIntoView({
    behavior: reducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });

  return true;
};

/**
 * Click handler for anchor links: smooth scroll + focus management.
 *
 * @example
 * ```tsx
 * <a href="#pricing" onClick={createSmoothScrollHandler()}>Pricing</a>
 * ```
 */
export const createSmoothScrollHandler = () => {
  return (e: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>): void => {
    const href = e.currentTarget.getAttribute('href');

    if (href?.startsWith('#')) {
      e.preventDefault();
      const targetId = href.slice(1);
      const scrolled = scrollToElement(targetId);

      if (scrolled) {
        focusElementAfterScroll(targetId, 500);
      }
    }
  };
};
